import { render, staticRenderFns } from "./PlanejamentoContratoFormProponente.vue?vue&type=template&id=0b526811"
import script from "./PlanejamentoContratoFormProponente.vue?vue&type=script&lang=js"
export * from "./PlanejamentoContratoFormProponente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports